import { isExternalLink } from '@adaptiva/core/common';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * @author Jesse Rogers <jesse.rogers@adaptiva.com>
 * @description This HTTP interceptor appends a header to all outgoing API requests: `X-ADAPTIVA-UI`.
 * 	The purpose of this header is to "tag" all API requests coming from the UI, so they can
 * 	be easily tracked by the server for reporting purposes.
 */
export const adaptivaUiHeaderInterceptor: HttpInterceptorFn = (_request: HttpRequest<any>, _handler: HttpHandlerFn): Observable<HttpEvent<any>> => {
	if (_request.method !== 'HEAD' && !isExternalLink(_request.url)) {
		_request = _request.clone({
			headers: _request.headers.set('x-adaptiva-ui', '1')
		});
	}

	return _handler(_request);
};
